const machine_txt = {
    type: "VA-1903-04",
    name: "HIGH SPEED COMPUTERIZED BUTTON SEWING MACHINE",
    description: [
        "The totally enclosed connecting bar,lubrication design to the eccentric wheel and gear,extend the machine life and decrease the noise",
        "High efficiency working performance Achieve the fast maximum speed 3000rpm, with the high speed performance, can fast start and stop sewing, with the fast trimmer and foot lifter, reduce the sewing cycle time",
        "Common Specifications",
        "Lubrication design to the gear extends the machine life and decreases the noise.",
        "The new thread trimmer design makes the trimming more stable and smoothg.",
        "New thread trimmer mechanism design.",
        "Advanced closed-loop control system, easy operation.",
        "The bottom thread clamp design, efficiently reduces the bottom thread problem of the light material.",
        "New type auto foot lifter and trimmer structure.",
    ],
    //绝对路径
    machine_img:[
        "/assets/machine/11/machine_img/1.jpg",
    ],
    machine_other_img:[
        "/assets/machine/11/machine_other/1.png",
        "/assets/machine/11/machine_other/2.png",
    ]
}
export default {machine_txt}